/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { isEmpty } from '@ember/utils';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class ReceiptRoute extends Route {
  queryParams = {
    personId: {
      refreshModel: false,
    },
  };

  // Services
  @service
  store;

  model(params) {
    let model = {
      payment: this.store.findRecord(
        'finance/transaction',
        params.transaction_id,
      ),
      tills: this.store.findAll('finance/till'),
      tillSessions: this.store.findAll('finance/till-session'),
      transactions: this.store.query('finance/transaction', {
        sourceTransactionId: params.transaction_id,
        include: 'accounts,ledgerItems,ledgers',
      }),
    };
    if (!isEmpty(params.personId)) {
      model.person = this.store.findRecord('person', params.personId);
    }
    return hash(model);
  }
}
